import axios from '@/lib/AxApi';

export default {
  getPatient(params, cb)
  {
    axios.get('/rest/Patients/getPatient',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  getPatients(params, cb)
  {
    axios.get('/rest/Patients/selectRow',
    {
      params: params
    })
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  },
  savePatient(params, cb)
  {
    if(typeof params.id != 'undefined' && params.id != '')
    {
      axios.post('/rest/Patients/updateRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
    else
    {
      axios.post('/rest/Patients/insertRow', params)
      .then(response => {
        cb(response.data);
      })
      .catch(e => {
        //TODO
      })
    }
  },
  deletePatient(params, cb)
  {
    axios.post('/rest/Patients/deleteRow', params)
    .then(response => {
      cb(response.data);
    })
    .catch(e => {
      //TODO
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/patients.js